import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { contact } from "@/lib/site-data";

export const Route = createFileRoute("/ochrana-osobnych-udajov")({
  head: () => ({
    meta: [
      { title: "Ochrana osobných údajov — ARTBAZ" },
      {
        name: "description",
        content:
          "Zásady ochrany osobných údajov spoločnosti ARTBAZ v súlade s GDPR a zákonom č. 18/2018 Z. z. o ochrane osobných údajov.",
      },
      { property: "og:title", content: "Ochrana osobných údajov — ARTBAZ" },
      {
        property: "og:description",
        content:
          "Informácie o spracúvaní a ochrane vašich osobných údajov v súlade s GDPR.",
      },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-28">
        <section className="bg-background py-16 md:py-20">
          <div className="container-artbaz">
            <div className="content-artbaz mx-auto max-w-3xl">
              <span className="eyebrow">Právne informácie</span>
              <h1 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
                Ochrana osobných údajov
              </h1>
              <p className="mt-6 text-sm text-muted-foreground">
                Posledná aktualizácia: 9. jún 2026
              </p>

              <div className="prose-artbaz mt-10 space-y-8 text-base leading-relaxed text-muted-foreground">
                <div>
                  <h2 className="text-xl font-bold text-foreground">1. Prevádzkovateľ</h2>
                  <p className="mt-3">
                    Prevádzkovateľom, ktorý určuje účel a prostriedky spracúvania osobných
                    údajov, je spoločnosť <strong className="text-foreground">ARTBAZ</strong> so
                    sídlom {contact.address[0]}, {contact.address[1]}. V prípade otázok
                    týkajúcich sa ochrany osobných údajov nás môžete kontaktovať na e-maile{" "}
                    <a href={`mailto:${contact.email}`} className="text-primary-dark underline">
                      {contact.email}
                    </a>{" "}
                    alebo telefonicky na čísle {contact.phone}.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground">
                    2. Aké údaje spracúvame a na aký účel
                  </h2>
                  <p className="mt-3">
                    Pri vyplnení a odoslaní kontaktného formulára spracúvame osobné údaje, ktoré
                    nám sami poskytnete: meno a priezvisko, telefónne číslo, e-mailová adresa,
                    typ požadovanej služby a obsah vašej správy. Tieto údaje spracúvame výlučne
                    za účelom:
                  </p>
                  <ul className="mt-3 list-disc space-y-1 pl-6">
                    <li>spätného kontaktovania a vybavenia vašej žiadosti či dopytu,</li>
                    <li>prípravy nezáväznej cenovej ponuky,</li>
                    <li>vzájomnej komunikácie súvisiacej s vaším projektom.</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground">3. Právny základ</h2>
                  <p className="mt-3">
                    Osobné údaje spracúvame na základe vášho súhlasu podľa čl. 6 ods. 1 písm. a)
                    Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 (GDPR) a zákona č.
                    18/2018 Z. z. o ochrane osobných údajov, prípadne na základe oprávneného
                    záujmu (čl. 6 ods. 1 písm. f) GDPR) spočívajúceho v odpovedi na vašu žiadosť.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground">4. Doba uchovávania</h2>
                  <p className="mt-3">
                    Osobné údaje uchovávame len po dobu nevyhnutnú na splnenie uvedeného účelu,
                    najdlhšie po dobu trvania komunikácie a vybavenia dopytu, prípadne po dobu
                    vyžadovanú platnými právnymi predpismi. Po uplynutí tejto doby údaje
                    bezpečne vymažeme.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground">5. Príjemcovia údajov</h2>
                  <p className="mt-3">
                    Vaše osobné údaje neposkytujeme tretím stranám na marketingové účely ani ich
                    nepredávame. Údaje môžu byť sprístupnené len poskytovateľom služieb (napr.
                    e-mailový a hostingový poskytovateľ), ktorí pre nás zabezpečujú technickú
                    prevádzku, a to vždy v súlade s GDPR.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground">6. Vaše práva</h2>
                  <p className="mt-3">
                    V súvislosti so spracúvaním osobných údajov máte právo na prístup k údajom,
                    ich opravu, vymazanie („právo na zabudnutie“), obmedzenie spracúvania,
                    prenosnosť údajov, ako aj právo kedykoľvek odvolať svoj súhlas a právo namietať
                    proti spracúvaniu. Tieto práva si môžete uplatniť na vyššie uvedených
                    kontaktoch. Zároveň máte právo podať sťažnosť na Úrad na ochranu osobných
                    údajov Slovenskej republiky.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground">7. Dobrovoľnosť poskytnutia</h2>
                  <p className="mt-3">
                    Poskytnutie osobných údajov je dobrovoľné. Bez ich poskytnutia vás však
                    nedokážeme spätne kontaktovať ani vybaviť vašu žiadosť.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
